import { AccordionSummary } from "@mui/material";

export const MuiAccordionSummary = AccordionSummary;
